import React, { useState } from "react";
import { Box, Button, TextField, Typography, useTheme, Card, CardContent, MenuItem, CircularProgress } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import SendIcon from "@mui/icons-material/Send";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../config";

const Notification = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [form, setForm] = useState({
    target: "drivers",
    title: "",
    message: "",
  });
  const [sending, setSending] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!form.title || !form.message) {
      toast.error("Veuillez remplir le titre et le message.");
      return;
    }
    setSending(true);
    try {
      const authToken = sessionStorage.getItem("authToken");
      const res = await fetch(`${API_BASE_URL}/admin/notifications/broadcast`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ authToken, ...form }),
      });
      const data = await res.json();
      if (data.success) {
        toast.success(data.message || "Notification diffusée avec succès !");
        setForm({ target: "drivers", title: "", message: "" });
      } else {
        toast.error(data.message || "Erreur d'envoi");
      }
    } catch (err) {
      console.error(err);
      toast.error("Erreur réseau");
    } finally {
      setSending(false);
    }
  };

  return (
    <Box m="20px">
      <Header title="DIFFUSION DE NOTIFICATIONS" subtitle="Envoyez des alertes et annonces en temps réel sur les téléphones" />

      <Box maxWidth="700px" mt="30px">
        <Card sx={{ backgroundColor: colors.primary[400] }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" color={colors.greenAccent[500]} fontWeight="bold" mb="20px">
              Nouvelle Annonce Push
            </Typography>

            <form onSubmit={handleSend}>
              <Box display="flex" flexDirection="column" gap={3}>
                <TextField
                  select
                  fullWidth
                  label="Destinataires"
                  value={form.target}
                  onChange={(e) => setForm({ ...form, target: e.target.value })}
                >
                  <MenuItem value="drivers">Tous les Chauffeurs LinkerVTC</MenuItem>
                  <MenuItem value="users">Tous les Passagers</MenuItem>
                </TextField>

                <TextField
                  fullWidth
                  label="Titre de la Notification"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                  placeholder="Ex: Mise à jour des tarifs / Bonus du week-end"
                  required
                />

                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Message de la Notification"
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="Rédigez le texte de l'annonce..."
                  required
                />

                <Button
                  type="submit"
                  variant="contained"
                  disabled={sending}
                  startIcon={sending ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                  sx={{
                    backgroundColor: colors.greenAccent[600],
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "12px",
                    fontSize: "15px",
                    "&:hover": { backgroundColor: colors.greenAccent[700] },
                  }}
                >
                  {sending ? "Diffusion en cours..." : "Diffuser la Notification Push"}
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Notification;
